
import { Constant } from "@/helpers/constant";
import { Employer } from "@/models/employer";
import { Component, Vue, Prop } from "vue-property-decorator";
import EmployerService from "../../services/employerService";
import { TranslateEn } from "@/languages/translate_en";
import { TranslateMalay } from "@/languages/translate_malay";
import NotificationService from "@/services/notificationService";
import JobseekerService from "../../services/jobseekerService";
import VueSkeletonLoader from "skeleton-loader-vue";
import AdminService from "@/services/adminService";
import SidHeader from "../sidbarMenu/sidHeader.vue";
import { checkMaintenanceMode } from "@/services/maintenanceService";
import SideBar from "../../module/dashboard/sideBar/sideBar.vue";

@Component({
  components: {
    SidHeader: SidHeader,
    SideBar: SideBar,
  },
})
export default class Header extends Vue {
  @Prop({ default: [] })
  routePath: string;
  menuItem = [];
  secondMenu = [];
  homeMenu = [];
  jobseekerMenu = [];
  employerMenu = [];
  adminMenu = [];
  fromHeader = false;
  token: string = "";
  type = "";
  loginType = "";
  activeMenu: string = "Home";
  $loading: any;
  employer: Employer = new Employer();
  count = 0;
  logourl = "";
  upskillUrl = "";
  upskillAgencyLoginUrl = Constant.upskill_agency_login_url;
  upskillTPLoginUrl = Constant.upskill_url+"auth/logintp";
  headermenu: any;
  jobseekermenuLang: any;
  selectedLanguage: string = "";
  customerId: any;
  notificationData: any = [];
  bearerToken: string;
  profileId: number;
  empId: number;
  //fcm
  userId: number;
  responseDataArray = [];
  fcmToken: string = "";

  //chat
  fromEmail: string = "";
  tokenFrom: any;
  myclientkey: any;
  keyToken: any;
  messages = [];
  newMessage: string = "";
  channel: any;
  clientkey: any;
  channelkey: any;
  displayStatus: boolean = false;
  employerCurrentObject: any = {};
  jobseekerCurrentObject: any = {};
  msgBoxFlag: boolean = false;
  currentMsgObj: any = {};
  loadingText: boolean = false;
  chatUserData: any[] = [];
  channelFrom: any;
  messageObjTemp = [];
  messagelength: number;
  page: number = 1;
  chatAdminUserData: any[] =[];
  activeSubTab: string ='';
  isMaintenanceModalVisible = false;
  
  showSidebar = true;
  showButtonMenu = false;

  redirectToJobSeekerLogin() {
    localStorage.removeItem("loginType");
    this.activeMenu = "Jobseeker";
    this.$router.push("/individualLogin");
  }

  redirectToEmployerLogin() {
    localStorage.removeItem("loginType");
    this.activeMenu = "Employer";
    this.$router.push("/employerLogin");
  }
  redirectToAdminLogin() {
    this.$router.push("/admin");
  }
  redirectToVideoPage() {
    this.$router.push("/videoPage");
  }
  redirectToContact() {
    this.$router.push("/contact-us");
  }
  redirectToInsight() {
    this.$router.push("/insights");
  }
  redirectToAgency() {
    window.location.href = this.upskillAgencyLoginUrl;
  }
    redirectToTP() {
    window.location.href = this.upskillTPLoginUrl;
  }
  redirectToEmpBenefits() {
    this.$router.push("/empbenefits");
  }
  redirectToIndBenefits() {
    this.$router.push("/indbenefits");
  }
  redirectToPartnership() {
    this.$router.push("/partnership");
  }
    downloadIndiUsermanual() {
    let route = this.$router.resolve({
      path: "/Individual_Module_User_ManualV1.0.pdf",
    });
    window.open(route.href);
  }
  downloadTpUsermanual() {
    let route = this.$router.resolve({
      path: "/TP_Module_User_ManualV3.0.pdf",
    });
    window.open(route.href);
  }
  downloadAgencyUsermanual() {
    let route = this.$router.resolve({
      path: "/Agency_Module_User_Manual_V1.0.pdf",
    });
    window.open(route.href);
  }
  downloadThisManual() {
    let route = this.$router.resolve({
      path: "/PTR_TA_TE_V1.0.pdf",
    });
    window.open(route.href);
  }
  downloadCIManual() {
    if (this.selectedLanguage == "en") {
      let route = this.$router.resolve({
        path: "/NTW_CI_ENG_V1.pdf",
      });
      window.open(route.href);
    } else {
      let route = this.$router.resolve({
        path: "/NTW_CI_BM_V1.pdf",
      });
      window.open(route.href);
    }
    
  }

  beforeUpdate() {
    const token = localStorage.getItem("bearerToken");
    this.upskillUrl = Constant.upskill_login_url + token;
    this.loginType = localStorage.getItem("loginType");
    if (this.loginType == "employer") {
      this.count = this.count + 1;
      if (this.count == 1) {
        this.getEmployer();
        this.updateOrCreateToken(token);
      }
    }

    if (this.loginType == "jobseeker") {
      //  this.getEmployersByAppliedJob();
      if (this.count == 1) {
        this.updateOrCreateToken(token);
      }
    }
    // this.getNotifications();
  }
  redirectToSingleWindow() {
    // window.location.href = this.upskillUrl;
    window.open(this.upskillUrl, "_blank");
  }

  async initMethod() {
    this.profileId = Number(localStorage.getItem("profileId"));
    if (this.loginType == "jobseeker") {
      this.fromEmail = localStorage.getItem("candEmail");
    } 
    else if (this.loginType == "employer") {
      this.fromEmail = localStorage.getItem("empEmail");
    }
    else if (this.loginType == "admin") {
      this.fromEmail = localStorage.getItem("adminEmail");
    }
  
    const token = await this.fetchToken(this.fromEmail);
    this.tokenFrom = token;
    const Chat = require("twilio-chat");
    const client = await Chat.Client.create(token);
    this.myclientkey = client;
    await this.initializeClient(token, client);
  }

  showMaintenanceModal() {
    this.isMaintenanceModalVisible = true
  }

  async initializeClient(token, client) {
    client.on("tokenAboutToExpire", async () => {
      const token = await this.fetchToken(this.fromEmail);
      client.updateToken(token);
    });
  }

  async fetchToken(emailid) {
    let type = "";
    if (this.loginType == "jobseeker") {
      type = "jobseeker";
    } else if (this.loginType == "employer") {
      type = "employer";
    }
     else if (this.loginType == "admin") {
      type = "admins";
    }
     else {
      type = "";
    }

    if (type != "") {
      let data = {
        email: emailid,
        userType: type,
      };
      await NotificationService.generateToken(data).then((response) => {
        this.keyToken = response.data;
        return this.keyToken;
      });
      return this.keyToken;
    }
  }

  async fetchMessages(channelFrom) {
    //let loader = this.$loading.show();
    this.loadingText = true;
    this.messages = (await channelFrom.getMessages(30)).items;
    this.messagelength = this.messages.length;
    this.loadingText = true;

    this.scrollBottom();
  }

  async sendMessage(toEmail) {
    if (
      this.newMessage != "" &&
      this.newMessage != undefined &&
      this.newMessage != null
    ) {
      this.msgBoxFlag = true;
      var channelFrom = await this.getCurrentChannel(toEmail);
      await channelFrom.sendMessage(this.newMessage);
      this.newMessage = "";
      this.msgBoxFlag = false;
      await this.fetchMessages(channelFrom);
      //await this.scrollBottom();
    }
  }

  async getCurrentChannel(toEmail) {
    const Chat = require("twilio-chat");
    var clientFrom = await Chat.Client.create(this.tokenFrom);
    if (this.loginType == "jobseeker") {
      var channelFrom = await clientFrom.getChannelByUniqueName(
        toEmail + "_" + this.fromEmail
      );
    } else if (this.loginType == "employer") {
      if(this.activeSubTab == "jobseeker")
      {
      var channelFrom = await clientFrom.getChannelByUniqueName(
        this.fromEmail + "_" + toEmail
      );
      }
      else if(this.activeSubTab == "admin")
      {
      var channelFrom = await clientFrom.getChannelByUniqueName(
        toEmail + "_" + this.fromEmail
      );   
      }
    }
    else if (this.loginType == "admin") {
      var channelFrom = await clientFrom.getChannelByUniqueName(
        this.fromEmail + "_" + toEmail
      );
    }
    return channelFrom;
  }

  async scrollBottom() {
    setTimeout(() => {
      var element = document.getElementById("chat-content");
      element.scrollTop = element.scrollHeight;
    }, 100);
  }

  //call when create channel

  async joinUserChannel(obj) {
    this.messages = [];
    if (this.loginType == "jobseeker") {
      this.joinUserChannelJob(obj);
    } 
    else if (this.loginType == "employer") {
      if(this.activeSubTab == "jobseeker")
      {
      this.joinUserChannelEmp(obj);
      }
      else if(this.activeSubTab == "admin")
      {
     this.joinUserChannelEmpAdmin(obj);
      }
    }
    else if (this.loginType == "admin") {
      this.joinUserChannelAdminEmployee(obj);
    }
  }

/**
 * Jobseeker_Employer Chat
 * create and join new channel 
 */
  async joinUserChannelJob(currentEmployerObject) {
    this.displayStatus = false;
    this.employerCurrentObject = currentEmployerObject;
    var tomail = currentEmployerObject.email;
    var myChannel = await this.getPublicChannel(tomail + "_" + this.fromEmail);
    //create and join new channel, if current channel is null
    if (myChannel == null) {
      await this.createChannel(tomail + "_" + this.fromEmail);
      await this.joinCurrentUser(tomail);
    } 
    else {
      /**
       * Get current channel , if already exist
       */
      var channelFrom = await this.getCurrentChannel(tomail);
      this.channelFrom = channelFrom;

      channelFrom.on("messageAdded", async (message) => {
        this.messages.push(message);
        this.scrollBottom();
      });
      await this.fetchMessages(channelFrom);
    }
    this.displayStatus = true;
  }

  async getPublicChannel(channelName) {
    var myChannel = null;
     var data =  await this.myclientkey.getChannelByUniqueName(channelName).then(function(paginator) {
        myChannel = paginator.channelState.status;
        return myChannel;
     }).catch(function(err) {
        console.log(err);
      });
    return myChannel;
  }

  createChannel(name) {
    let newChannelName = name;
    this.myclientkey
      .createChannel({
        uniqueName: newChannelName,
        friendlyName: newChannelName,
        //isPrivate: true
      })
      .then(function(channel) {
        return "created";
      })
      .catch(function(err) {
        return "not";
      });
  }

  //call when new chat create
  async joinCurrentUser(toEmail) {
    var tokenFrom = await this.fetchToken(this.fromEmail);
    const Chat = require("twilio-chat");
    var clientFrom = await Chat.Client.create(tokenFrom);
    var channelFrom = await clientFrom.getChannelByUniqueName(
      toEmail + "_" + this.fromEmail
    );
    channelFrom = channelFrom;

    // Join a previously created channel
    clientFrom.on("channelJoined", async (channel) => {});
    channelFrom.join().then((channel) => {
      this.channelFrom.on("messageAdded", function(message) {}); 
    });
    await this.joinToChannel(toEmail);
  }

  async joinToChannel(toEmail) {
    var toToken = await this.fetchToken(toEmail);
    const Chat = require("twilio-chat");
    var clientsTo = await Chat.Client.create(toToken);
    var channelTo = await clientsTo.getChannelByUniqueName(
      toEmail + "_" + this.fromEmail
    );
    clientsTo.on("channelJoined", async (channel) => {});
    channelTo.join().then((channel) => {
      this.channelFrom.on("messageAdded", function(message) {});
    });
  }

  dateToString(dateVal) {
    return dateVal.toString();
  }

  // for employer

  getJobSeekerByEmployerJob() {
    this.empId = Number(localStorage.getItem("empId"));

    let loader = this.$loading.show();

    let data = {
      provider: Constant.EMPLOYER_PROVIDER,
      empid: this.empId,
    };
    JobseekerService.getJobSeekerByEmployerJob(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
            if (response.data.data != null) {
              this.chatUserData = response.data.data;
            } else {
              this.chatUserData = [];
            }
        }
      }
    });
  }

  async sendMessageEmp(toEmail) {
    if (
      this.newMessage != "" &&
      this.newMessage != undefined &&
      this.newMessage != null
    ) {
      this.msgBoxFlag = true;
      var channelFrom = await this.getCurrentChannel(toEmail);
      await channelFrom.sendMessage(this.newMessage);
      this.newMessage = "";
      this.msgBoxFlag = false;
      await this.fetchMessages(channelFrom);
      //await this.scrollBottom();
    }
  }

  async joinUserChannelEmp(obj) {
    this.displayStatus = false;
    this.jobseekerCurrentObject = obj;
    // let loader = this.$loading.show();
    var tomail = obj.email;
    var myChannel = await this.getPublicChannel(this.fromEmail + "_" + tomail);
    if (myChannel == null) {
      await this.createChannel(this.fromEmail + "_" + tomail);
      await this.joinCurrentUserEmp(tomail);
    } else {
      var channelFrom = await this.getCurrentChannel(tomail);
      channelFrom.on("messageAdded", async (message) => {
        this.messages.push(message);
        this.scrollBottom();
      });
      this.channelFrom = channelFrom;
      await this.fetchMessages(channelFrom);
      this.displayStatus = true;
    }
    this.displayStatus = true;
  }

// for admin login : admin_employer
 async joinUserChannelAdminEmployee(obj) {
    this.displayStatus = false;
    this.jobseekerCurrentObject = obj;
    // let loader = this.$loading.show();
    var tomail = obj.email;
    var myChannel = await this.getPublicChannel(this.fromEmail + "_" + tomail);
    if (myChannel == null) {
      await this.createChannel(this.fromEmail + "_" + tomail);
      await this.joinCurrentUserAdminEmp(tomail);
    } else {
      var channelFrom = await this.getCurrentChannel(tomail);
      channelFrom.on("messageAdded", async (message) => {
        this.messages.push(message);
        this.scrollBottom();
      });
      this.channelFrom = channelFrom;
      await this.fetchMessages(channelFrom);
      this.displayStatus = true;
    }
    this.displayStatus = true;
  }

  async joinCurrentUserAdminEmp(toEmail) {
    var tokenFrom = await this.fetchToken(this.fromEmail);
    const Chat = require("twilio-chat");
    var clientFrom = await Chat.Client.create(tokenFrom);
    var channelFrom = await clientFrom.getChannelByUniqueName(
      this.fromEmail + "_" + toEmail
    );

    this.channelFrom = channelFrom;

    // Join a previously created channel
    clientFrom.on("channelJoined", async (channel) => {});
    channelFrom.join();
    await this.joinToChannelAdminEmp(toEmail);
  }

  async joinToChannelAdminEmp(toEmail) {
    var toToken = await this.fetchToken(toEmail);
    const Chat = require("twilio-chat");
    var clientsTo = await Chat.Client.create(toToken);
    var channelTo = await clientsTo.getChannelByUniqueName(
      this.fromEmail + "_" + toEmail
    );
    clientsTo.on("channelJoined", async (channel) => {});
    channelTo.join();
  }


  //
  // employer to admin chat
 async joinUserChannelEmpAdmin(currentEmployerObject) {
    this.displayStatus = false;
    this.employerCurrentObject = currentEmployerObject;
    var tomail = currentEmployerObject.email;
    var myChannel = await this.getPublicChannel(tomail + "_" + this.fromEmail);
    if (myChannel == null) {
      await this.createChannel(tomail + "_" + this.fromEmail);
      await this.joinCurrentUserEmpAdmin(tomail);
    } else {
      var channelFrom = await this.getCurrentChannel(tomail);

      this.channelFrom = channelFrom;

      channelFrom.on("messageAdded", async (message) => {
        this.messages.push(message);
        this.scrollBottom();
      });

      await this.fetchMessages(channelFrom);
    }
    this.displayStatus = true;
  }

  async joinCurrentUserEmpAdmin(toEmail) {
    var tokenFrom = await this.fetchToken(this.fromEmail);
    const Chat = require("twilio-chat");
    var clientFrom = await Chat.Client.create(tokenFrom);
    var channelFrom = await clientFrom.getChannelByUniqueName(
      toEmail + "_" + this.fromEmail
    );
    channelFrom = channelFrom;

    // Join a previously created channel
    clientFrom.on("channelJoined", async (channel) => {});
    channelFrom.join().then((channel) => {
      this.channelFrom.on("messageAdded", function(message) {});
    });
    await this.joinToChannelEmpAdmin(toEmail);
  }

  async joinToChannelEmpAdmin(toEmail) {
    var toToken = await this.fetchToken(toEmail);
    const Chat = require("twilio-chat");
    var clientsTo = await Chat.Client.create(toToken);
    var channelTo = await clientsTo.getChannelByUniqueName(
      toEmail + "_" + this.fromEmail
    );
    clientsTo.on("channelJoined", async (channel) => {});
    channelTo.join().then((channel) => {
      this.channelFrom.on("messageAdded", function(message) {});
    });
  }
  //

  //emp login
  async joinCurrentUserEmp(toEmail) {
    var tokenFrom = await this.fetchToken(this.fromEmail);
    const Chat = require("twilio-chat");
    var clientFrom = await Chat.Client.create(tokenFrom);
    var channelFrom = await clientFrom.getChannelByUniqueName(
      this.fromEmail + "_" + toEmail
    );

    this.channelFrom = channelFrom;

    // Join a previously created channel
    clientFrom.on("channelJoined", async (channel) => {});
    channelFrom.join();
    await this.joinToChannelEmp(toEmail);
  }

  async joinToChannelEmp(toEmail) {
    var toToken = await this.fetchToken(toEmail);
    const Chat = require("twilio-chat");
    var clientsTo = await Chat.Client.create(toToken);
    var channelTo = await clientsTo.getChannelByUniqueName(
      this.fromEmail + "_" + toEmail
    );
    clientsTo.on("channelJoined", async (channel) => {});
    channelTo.join();
  }

  async getChatUsers() {
    // if (
    //   this.chatUserData != null &&
    //   this.chatUserData.length != 0 &&
    //   this.chatUserData != undefined
    // ) {
      if (this.loginType == "jobseeker") {
        await this.initMethod();
        await this.getEmployersByAppliedJob();
      }
      if (this.loginType == "employer") {
        await this.initMethod();
        await this.getJobSeekerByEmployerJob();
	      this.activeSubTab = 'jobseeker';
      }
      if(this.loginType == "admin")
      {
        await this.initMethod();
        await this.getAllEmployers();
      }
   // }
  }

  getAllEmployerAdmins()
  {
    let loader = this.$loading.show();
    AdminService.getAllEmployerAdmins().then(response => {
      loader.hide();
      if (response != undefined) {

        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
          if (response.data.data != null) {
           this.chatAdminUserData  = response.data.data;
          } else {
              this.chatAdminUserData = [];
          }
        }
      }
    });
  }

   getAllEmployers() {
     this.chatUserData = [];
    let data = {
      provider: Constant.ADMIN_PROVIDER,
      page: this.page,
      status: "ACTIVE"
    };
    let loader = this.$loading.show();
    AdminService.getAllEmployersByStatus(data).then(response => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if (
            response.data != undefined &&
            response.data != null &&
            response.data.data != undefined &&
            response.data.data != null
          )
          if (response.data.data != null) {
           this.chatUserData  = response.data.data;
          } else {
              this.chatUserData = [];
          }
        }
      }
    });
  }

  async created() {
    
    this.customerId = localStorage.getItem("profileId");
    this.loginType = localStorage.getItem("loginType");

    this.getLatitudeLongitude();
    if (
      localStorage.getItem("selectedlanguage") != undefined &&
      localStorage.getItem("selectedlanguage") != null
    ) {
      this.selectedLanguage = localStorage.getItem("selectedlanguage");
    } else {
      localStorage.setItem("selectedlanguage", "ms");
      this.selectedLanguage = "ms";
    }
    if (this.selectedLanguage == "en") {
      this.headermenu = TranslateEn.headerMenu;
      this.jobseekermenuLang = TranslateEn.jobSeekerMenu;
    } else {
      this.headermenu = TranslateMalay.headerMenu;
      this.jobseekermenuLang = TranslateMalay.jobSeekerMenu;
    }

    if (this.loginType == "jobseeker") {
      this.initMethod();
      this.getEmployersByAppliedJob();
      this.activeSubTab = '';
    }
    if (this.loginType == "employer") {
      this.initMethod();
      this.getJobSeekerByEmployerJob();
      this.activeSubTab = 'jobseeker';
    }
    if (this.loginType == "admin") {
      this.initMethod();
      this.getAllEmployers();
      this.activeSubTab = '';
    }
    this.homeMenu = [
      {
        label: this.headermenu.home,
        to: "/",
      },
      {
        label: this.headermenu.aboutUpskill,
        to: "/aboutus",
      },
      // {
      // label: this.headermenu.courses,
      // to: "/courseList",
      // },
      {
        label: this.headermenu.courses,
        items: [
          {
            label: this.headermenu.active_courses,
            to: "/courseList",
          },
          {
            label: this.headermenu.archived_courses,
            to: "/archivedCourseList",
          },
        ],
      },
      {
        label: this.headermenu.satelliteevents,
        to: "/satelliteEventList",
      },
      {
      label:this.headermenu.insights,
      to: "/guidelines",
      // items:[
          // {
          //   label:this.headermenu.insightsSubMenu.reportArticles,
          //   to: "/insights",
          // },
          // {
          //   label:this.headermenu.insightsSubMenu.skillFramework,
          //   to: "/indSF",
          // },
          // {
          //   label: this.headermenu.guidelines,
            // items: [
            //   {
            //     label: this.headermenu.individuals,
            //     command: (event) => {
            //       this.downloadIndiUsermanual();
            //     },
            //   },
            //   {
            //     label: this.headermenu.tp,
            //     command: (event) => {
            //       this.downloadTpUsermanual();
            //     },
            //   },
            //   {
            //     label: this.headermenu.manual1,
            //     command: (event) => {
            //       this.downloadThisManual();
            //     },
            //   },
            //   {
            //     label: this.headermenu.cimanual,
            //     // command: (event) => {
            //     //   this.downloadCIManual();
            //     // },
            //     to: "/guidelines",
            //   },

            //   // {
            //   //   label: this.headermenu.agency,
            //   //   command: (event) => {
            //   //     this.downloadAgencyUsermanual();
            //   //   },
            //   // }
            // ],
          // },
        // ]
      },
      // {
      // label:this.headermenu.contactUs,
      // to: "/contact-us",
      // },
      // {
      //   label: this.headermenu.faq,
      //   to: "/faq",
      // },
      // {
      //   label: this.headermenu.contactUs,
      //   to: "/contact-us",
      // },
      // {
      //   label:this.headermenu.satelliteevents,
      //   // to: "/contact-us",
      // },
    ];
    this.jobseekerMenu = [
      {
        header: true,
        component: SidHeader,
        hiddenOnCollapse: true
      },
      {
        title: this.jobseekermenuLang.home,
        icon: 'fas fa-home',
        href: '/individualDashboard'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/individualDashboard");
        // },
      },
      {
        title: this.jobseekermenuLang.courses,
        icon: 'fas fa-chalkboard-teacher',
        href: '/courseSearch'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/courseSearch");
        // },
      },
      {
        title: this.jobseekermenuLang.satelliteEvents,
        href: "/satelliteEventSearch",
        icon: 'fas fa-folder',
      },
      // {
      //   title: this.jobseekermenuLang.archive_courses,
      //   icon: 'fas fa-folder',
      //   href: '/archivedCourseSearch'
      //   // command: (event) => {
      //   //   localStorage.removeItem("searchJobSkills");
      //   //   this.$router.push("/courseSearch");
      //   // },
      // },
      {
        title: this.jobseekermenuLang.appliedCourses,
        href: "/courseHistoryForIndividual",
        icon: 'fas fa-search',
      },
      {
        title: this.jobseekermenuLang.myProfiles,
        icon: 'fas fa-users',
        href: '/profile'
        // command: (event) => {
        //   localStorage.removeItem("searchJobSkills");
        //   this.$router.push("/profile");
        // },
      }
    ],

    this.employerMenu = [
      {
        label: "Home",
        to: "/employerDashboard",
      },
      {
        label: "Candidate Search",
        to: "/candidateSearch",
      },
      {
        label: "Course Search",
        to: "/allCourses",
      },
      {
        label: "Active Job Posts",
        command: (event) => {
          localStorage.removeItem("searchSkills");
          this.$router.push("/listJob");
        },
      },
      {
        label: "Applicants",
        items: [
          {
            label: "Applicants",
            to: "/appliedJobList",
          },
          {
            label: "Saved Candidates",
            to: "/savedCandidates",
          },
          {
            label: "Advertisements",
            to: "/listAds",
          },
        ],
      },
      {
        label: "HR/Users/Employee",
        items: [
          {
            label: "Add HR/Users",
            to: "/addEmployer",
          },
          {
            label: "List HR/Users",
            to: "/hrUserList",
          },
          {
            label: "Add Employee",
            to: "/registerEmployee",
          },
          {
            label: "List Employees",
            to: "/listEmployee",
          },
        ],
      },
      {
        label: "Post Job",
        to: "/addJob",
      },
    ];
    this.adminMenu = [
      // {
      //   label: "Dashboard",
      //   items: [
      //     {
      //       label: "Statistics",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/adminStatistics");
      //       },
      //     },
      //     {
      //       label: "Application Stats Reports",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/applicationStatsReport");
      //       },
      //     },
      //     {
      //       label: "Registration",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/adminReport");
      //       },
      //     },
      //     {
      //       label: "Job Analytics",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/stateReport");
      //       },
      //     },
      //     {
      //       label: "Employment TypeWise Job Reports",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/employmentTypeReport");
      //       },
      //     },
      //     {
      //       label: "Job Vacancy Vs Applications",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/vacancyReport");
      //       },
      //     },
      //   ],
      // },
      // {
      //   label: "Reports",
      //   items: [
      //     {
      //       label: "Jobseeker",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/jobseekerReport");
      //       },
      //     },
      //     {
      //       label: "Employer",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/employerReport");
      //       },
      //     },
      //     {
      //       label: "Export Reports",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/exportReports");
      //       },
      //     },
      //     {
      //       label: "Jobseeker Email Blast",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/sendBulkEmail");
      //       },
      //     },
      //      {
      //       label: "Employer Email Blast",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/sendEmployerBulkEmail");
      //       },
      //     },
      //   ],
      // },
      // {
      //   label: "Employer List",
      //   items: [
      //     {
      //       label: "Pending Approval",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/pendingEmployer");
      //       },
      //     },
      //     {
      //       label: "Approved",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/approvedEmployer");
      //       },
      //     },
      //     {
      //       label: "Denied",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/deniedEmployer");
      //       },
      //     },
      //     {
      //       label: "De-Activated",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/deActivatedEmployer");
      //       },
      //     },
      //     {
      //       label: "Advertisements",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/advertisementList");
      //       },
      //     },
      //   ],
      // },
      {
        label: "Jobseeker List",
        command: (event) => {
          localStorage.removeItem("searchSkills");
          localStorage.removeItem("searchJobSkills");
          this.$router.push("/jobseekerList");
        },
      },
      // {
      //   label: "Posted Job List",
      //   command: (event) => {
      //     localStorage.removeItem("searchSkills");
      //     localStorage.removeItem("searchJobSkills");
      //     this.$router.push("/listJob");
      //   },
      // },
      // {
      //   label: "Search",
      //   items: [
      //     {
      //       label: "Jobseeker Search",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/jobseekerSearch");
      //       },
      //     },
      //     {
      //       label: "Employer Search",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/employerSearch");
      //       },
      //     },
      //     {
      //       label: "Posted Job Search",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/postedJobSearch");
      //       },
      //     },
      //   ],
      // },
      {
        label: "Single Window",
        command: (event) => {
          this.redirectToSingleWindow();
        },
      },
      // {
      //   label: "Assessment",
      //   items: [
      //     {
      //       label: "Skill Assessment",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/assessmentList");
      //       },
      //     },
      //     {
      //       label: "Personality Development Assessment",
      //       command: (event) => {
      //         localStorage.removeItem("searchSkills");
      //         localStorage.removeItem("searchJobSkills");
      //         this.$router.push("/PDQuestionList");
      //       },
      //     }
      //   ]
      // },
        {
        label: "Keyskills",
        items: [
          {
            label: "View KeySkills",
            command: (event) => {
          
              this.$router.push("/viewkeyskills");
            },
          },
     
        ]
      },
       {
        label: "Course Appeal",
        command: (event) => {
          this.$router.push("/courseAppeal");
        },
      },
    ];
    this.getNotifications();

    // Check if the application is in maintenance mode
    // const isMaintenanceMode = checkMaintenanceMode()
    // if (await isMaintenanceMode == true) {
    //   this.showMaintenanceModal()
    // }
    
  }
  mounted() {
    
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    window.addEventListener("scroll", this.scrollEvent, true);
  }
  ngOnInit() {
    window.addEventListener("scroll", this.scrollEvent, true);
  }

  ngOnDestroy() {
    window.removeEventListener("scroll", this.scrollEvent, true);
  }
  scrollEvent = (event: any): void => {
    if (
      this.routePath == "/" ||
      this.routePath == "/innerPage" ||
      this.routePath == "/videoPage" ||
      this.routePath == "/insights" ||
      this.routePath == "/contact-us" ||
      this.routePath == "/indSF" ||
      this.routePath == "/agencyEcer" ||
      this.routePath == "/agency" ||
      this.routePath == "/agencyKbs" ||
      this.routePath == "/agencyKpt" ||
      this.routePath == "/agencyMara" ||
      this.routePath == "/agencyMedac" ||
      this.routePath == "/agencyMotac" ||
      this.routePath == "/agencyNcia" ||
      this.routePath == "/aboutus" ||
      this.routePath == "/aboutusp" ||
      this.routePath == "/empbenefit" ||
      this.routePath == "/hiring" ||
      this.routePath == "/trainingexemp" ||
      this.routePath == "/funding" ||
      this.routePath == "/otherpgm" ||
      this.routePath == "/hrconsult" ||
      this.routePath == "/indbenefit" ||
      this.routePath == "/partnership" ||
      this.routePath == "/elatih" ||
      this.routePath == "/insightsnew" ||
      this.routePath == "/reportarcticle" ||
      this.routePath == "/indskills" ||
      this.routePath == "/upskillinsights" ||
      this.routePath == "/courseDetails" ||
      this.routePath == "/faq" ||
      this.routePath == "/privacyPolicy" ||
      this.routePath == "/courseList"
      // this.routePath == "/upskillstatis"
    ) {
      var nav = document.getElementById("nav");
      if (window.pageYOffset >= 100) {
        nav.classList.add("nav-bar1");
        nav.classList.remove("listNav");
      } else {
        nav.classList.remove("nav-bar1");
      }
    }
  };

  getEmployer() {
    let data = {
      provider: Constant.EMPLOYER_PROVIDER,
    };
    let loader = this.$loading.show();
    EmployerService.getCurrentEmployer(data).then((response) => {
      loader.hide();
      if (response != undefined && response.data != undefined) {
        if (response.data.status == 200) {
          if (response.data.data != undefined && response.data.data != null) {
            this.employer = response.data.data;
            if (this.employer.status == Constant.ACTIVE) {
              this.employerMenu = [
                {
                  label: "Home",
                  to: "/employerDashboard",
                },
                {
                  label: "Candidate Search",
                  to: "/candidateSearch",
                },
                {
                  label: "Course Search",
                  to: "/allCourses",
                },
                {
                  label: "Active Job Posts",
                  to: "/listJob",
                },
                {
                  label: "Applicants",
                  items: [
                    {
                      label: "Applicants",
                      to: "/appliedJobList",
                    },
                    {
                      label: "Saved Candidates",
                      to: "/savedCandidates",
                    },
                    //  {
                    //   label:'Candidate Chat',
                    //   to: "/employerChat",
                    // },
                    {
                      label: "Advertisements",
                      to: "/listAds",
                    },
                  ],
                },
                {
                  label: "HR/Users/Employee",
                  items: [
                    {
                      label: "Add HR/Users",
                      to: "/addEmployer",
                    },
                    {
                      label: "List HR/Users",
                      to: "/hrUserList",
                    },
                    {
                      label: "Add Employee",
                      to: "/registerEmployee",
                    },
                    {
                      label: "List Employees",
                      to: "/listEmployee",
                    },
                  ],
                },
                {
                  label: "Post Job",
                  to: "/addJob",
                },
              ];
            } else {
              this.employerMenu = [];
            }
            if (
              response.data.data.logourl != undefined &&
              response.data.data.logourl != null &&
              response.data.data.logourl != ""
            ) {
              this.logourl = response.data.data.logourl.replace(
                Constant.OSSInternalURL,
                Constant.OSSReplaceURL
              );
            }
          }
        }
      }
    });
   
  }

  updateOrCreateToken(btoken) {
    this.fcmToken = localStorage.getItem("fcmtoken");
    this.profileId = Number(localStorage.getItem("profileId"));
    this.loginType = localStorage.getItem("loginType");
    this.empId = Number(localStorage.getItem("empId"));
    let userId;
    if (this.loginType == "employer") {
      userId = this.empId;
    } else if (this.loginType == "jobseeker") {
      userId = this.profileId;
    }
    if (
      btoken != null &&
      btoken != "" &&
      this.fcmToken != undefined &&
      this.fcmToken != null &&
      this.fcmToken != ""
    ) {
      let data = {
        userId: userId,
        token: this.fcmToken,
        userType: this.loginType.toUpperCase(),
      };
      //let loader = this.$loading.show();
      NotificationService.updateOrCreateToken(data).then((data) => {
        //   loader.hide();
        if (data != undefined && data.data != undefined) {
          if (data.data.status == 200) {
          }
        }
      });
    }
  }

  getDaysFromDate(createdDate) {
    const timeDiff = Math.abs(
      (new Date() as any) - (new Date(createdDate) as any)
    );
    const days = timeDiff / (1000 * 60 * 60 * 24);
    return Math.round(days);
  }

  getNotifications() {
    this.bearerToken = localStorage.getItem("bearerToken");
    this.profileId = Number(localStorage.getItem("profileId"));
    this.empId = Number(localStorage.getItem("empId"));
    let userId;
    if (this.loginType == "employer") {
      userId = this.empId;
    } else if (this.loginType == "jobseeker") {
      userId = this.profileId;
    }

    if (this.bearerToken != null && this.bearerToken != "") {
      let data = {
        userId: userId,
        userType: this.loginType.toUpperCase(),
      };
      //let loader = this.$loading.show();
      NotificationService.getNotifications(data).then((response) => {
        // loader.hide();
        if (response != undefined && response.data != undefined) {
          if (response.data.status == 200) {
            if (response.data.data != undefined && response.data.data != null) {
              this.notificationData = response.data.data;
            }
          }
        }
      });
    }
  }
  logout() {
    this.count = 0;
    localStorage.clear();
    this.$store.commit("dashboard/setJobseekerData", null);
    this.$store.commit("dashboard/setKeySkillListData", null);
    this.$store.commit("dashboard/setAllPillarsData", null);
    this.$router.push("/");
  }

  chooseLanguage(lang) {
    if (lang != null) {
      localStorage.setItem("selectedlanguage", lang);
      window.location.reload();
    }
  }

  show() {
    if(this.activeSubTab == "admin")
    {
    document.getElementById("hideChatempadmin").style.display = "flex";
    }
    else
    {
    document.getElementById("hideChat").style.display = "flex";
    }
  }
  hide() {
    if(this.activeSubTab == "admin")
    {
    document.getElementById("hideChatempadmin").style.display = "none";
    }
    else
    {
    document.getElementById("hideChat").style.display = "none";
    }
  }

  //jobseeker
  getEmployersByAppliedJob() {
    this.profileId = Number(localStorage.getItem("profileId"));
    if (this.profileId != null) {
      //  let loader = this.$loading.show();

      let data = {
        provider: Constant.JOBSEEKER_PROVIDER,
        jobseekerid: this.profileId,
      };
      EmployerService.getEmployersByAppliedJob(data).then((response) => {
        //   loader.hide();

        if (response != undefined) {
          if (response.status == 200) {
            if (
              response.data != undefined &&
              response.data != null &&
              response.data.data != undefined &&
              response.data.data != null
            )
              if (response.data.data != null) {
                this.chatUserData = response.data.data;
              } else {
                this.chatUserData = [];
              }
          }
        }
      });
    }
  }
  tabActiveChange(activeSubTab) {
    this.activeSubTab = activeSubTab;
    if(activeSubTab == 'admin')
    {
        this.getAllEmployerAdmins();
    }
     if(activeSubTab == 'jobseeker')
    {
        this.getJobSeekerByEmployerJob();
    }
  }

  
   getLatitudeLongitude() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(this.showPosition);
  } 
}

 showPosition(position) {
       localStorage.setItem("currentLatitude",position.coords.latitude);
       localStorage.setItem("currentLongitude",position.coords.longitude);
  }

  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); // Clean up
  }
  toggleSidebar() {
    this.showSidebar = !this.showSidebar;
    this.showButtonMenu = !this.showButtonMenu;
  }

  handleResize() {
    if (window.innerWidth <= 1024) {
      this.showSidebar = false;
      this.showButtonMenu = false;
    } else {
      this.showSidebar = true;
      this.showButtonMenu = false;
    }
  }

}

